import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-blue.css';
import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useState } from 'react';
import '../../assets/css/ag-grid.css';
import useAuthz from '../../hooks/useAuthz';

const AgGrid = (props) => {
        const { gridOptions, setGridOptions, gridName, style, checkAll, setGridSelectedValues, type } = props;
        const [rowSelection] = useState(props.rowSelection || 'single');
        const [excelStyles] = useState(props.excelStyles || []);
        const [context] = useState({ componentParent: this });
        const [authz, user, profil] = useAuthz();
        const [localeText] = useState({
            andCondition: 'et',
            orCondition: 'ou',
            page: 'Page',
            more: 'Plus',
            to: 'de',
            of: 'à',
            next: 'Suivant',
            last: 'Dernier',
            first: 'Premier',
            previous: 'Précédent',
            loadingOoo: 'Chargement...',
            selectAll: 'Sélectionner tout',
            searchOoo: 'Recherche...',
            blanks: 'Vide',
            filterOoo: 'Filtre...',
            applyFilter: 'Appliquer',
            resetFilter: 'Réinitialiser',
            equals: 'Égal',
            notEqual: 'Non égal',
            lessThan: 'Inférieur à',
            greaterThan: 'Supérieur à',
            lessThanOrEqual: 'Inférieur ou égal',
            greaterThanOrEqual: 'Supérieur ou égal',
            inRange: 'Dans la plage',
            contains: 'Contient',
            notContains: 'Ne contient pas',
            startsWith: 'Commence par',
            endsWith: 'Termine par',
            group: 'Groupe',
            columns: 'Colonne',
            filters: 'Filtres',
            rowGroupColumns: 'Colonne groupe',
            rowGroupColumnsEmptyMessage: 'Colonne groupe vide',
            valueColumns: 'Valeur de colonne',
            pivotMode: 'Mode pivot',
            groups: 'Groupe',
            values: 'Valeur',
            pivots: 'Pivot',
            valueColumnsEmptyMessage: 'Glisser la colonne pour aggréger',
            pivotColumnsEmptyMessage: 'Glisser la colonne pour pivot',
            toolPanelButton: 'Bouton du panneau d\'outils',
            noRowsToShow: 'Aucune ligne à afficher',
            pinColumn: 'Colonne épinglée',
            valueAggregation: 'Valeur aggrégée',
            autosizeThiscolumn: 'Redimensionnement automatique pour cette colonne',
            autosizeAllColumns: 'Redimensionnement automatique pour toutes les colonnes',
            groupBy: 'Grouper par',
            ungroupBy: 'Dégrouper par',
            resetColumns: 'Réinitialiser colonnes',
            expandAll: 'Afficher tout',
            collapseAll: 'Masquer tout',
            toolPanel: 'Panneau d\'outils',
            export: 'Export',
            csvExport: 'Export en CSV',
            excelExport: 'Export en Excel',
            pinLeft: 'Épingler à gauche',
            pinRight: 'Épingler à droite',
            noPin: 'Ne pas épingler',
            sum: 'Somme',
            min: 'Minimum',
            max: 'Maximum',
            none: 'Aucun',
            count: 'Total',
            average: 'Moyenne',
            copy: 'Copier',
            copyWithHeaders: 'Copier avec les entêtes',
            ctrlC: 'Ctrl + C',
            paste: 'Coller',
            ctrlV: 'Ctrl + V',
        });
        const [gridApi, setGridApi] = useState();

        const [isResizing, setIsResizing] = useState(false);
        const [isLoading, setIsLoading] = useState(true);
        const hasResizedWithDataRef = React.useRef(false);

        useEffect(() => {
            if (!hasResizedWithDataRef.current && props.rowData && props.rowData.length > 0 && gridOptions.columnApi) {
                hasResizedWithDataRef.current = true;
                resizeAllColumns();
            }
        }, [props.rowData]);

        useEffect(async () => {
            if (!isLoading) {
                let filtersStorage = await loadFilters();
                let filterModel = gridOptions.api?.getFilterModel();

                filterModel = {
                    ...filterModel,
                    ...filtersStorage,
                };

                if (gridOptions.api && gridName && gridName === 'ag-grid-heritage-element') {

                    delete filterModel.linkedAxis;
                    delete filterModel.direction;
                    delete filterModel.landmark;

                    if (props.filters) {
                        let type = props.filters.type;

                        let prStart;
                        let prEnd;
                        let filterPassType;

                        if (type === 'superieur') {
                            prStart = Number(props.filters.prStart) - Number(props.filters.prScaleSearch);
                            prEnd = Number(props.filters.prStart) + Number(props.filters.prScaleSearch);

                            filterPassType = {
                                type: 'contain',
                                filter: 'sup',
                            };

                        } else {
                            prStart = Number(props.filters.prStart);
                            prEnd = Number(props.filters.prEnd);

                            if (!prEnd) {
                                prEnd = 999;
                            }

                            if (!prStart) {
                                prStart = 0;
                            }
                        }

                        if (prStart > prEnd) {
                            let temp = prStart;
                            prStart = prEnd;
                            prEnd = temp;
                        }

                        let landMarkFilter = { type: 'inRange', filter: prStart, filterTo: prEnd };

                        filterModel = {
                            ...filterModel,
                            linkedAxis: { type: 'equals', filter: props.filters.linkedAxis || '' },
                            direction: { type: 'equals', filter: props.filters.direction || '' },
                            landmark: landMarkFilter,
                        };
                    }
                }

                if (gridApi && gridName === 'ag-grid-liste-devis-factures') {
                    if (props.filters && props.filters.dossier_id !== null) {
                        filterModel = {
                            ...filterModel,
                            'dossier_id': { type: 'equals', filter: props.filters.dossier_id },
                        };
                    } else {
                        filterModel = {
                            ...filterModel,
                            'dossier_id': '',
                        };
                    }
                }

                if (gridApi && gridName === 'ag-grid-planification') {
                    if (props.filters && props.filters.id !== null) {
                        filterModel = {
                            ...filterModel,
                            'id': { type: 'equals', filter: props.filters.id },
                        };
                    } else {
                        filterModel = {
                            ...filterModel,
                            'id': '',
                        };
                    }

                }

                if (gridApi && gridName === 'ag-grid-grille-tarifaire-table') {
                    filterModel = { ...filterModel, 'centre_id': { type: 'set', filter: props.filters.centre_id } };
                }

                if (gridApi && gridName === 'ag-grid-edit-devis-table') {
                    filterModel = {
                        ...filterModel,
                        'libelle': { type: 'contains', filter: props.filters.libelle },
                        'centre': { type: 'contains', filter: props.filters.centre },
                    };
                }

                if (gridOptions.api && (gridName === 'ag-grid-heritage-element' || gridName === 'ag-grid-liste-devis-factures' || gridName === 'ag-grid-grille-tarifaire-table' || gridName === 'ag-grid-edit-devis-table' || gridName === 'ag-grid-planification')) {
                    setTimeout(() => {
                        gridOptions.api?.setFilterModel(filterModel);
                    }, 400);
                }
            }
        }, [isLoading]);

        useEffect(() => {
            if (gridApi && !isLoading) {
                if (gridApi && gridName === 'ag-grid-edit-devis-table') {
                    let filterModel = {
                        ...gridOptions.api?.getFilterModel(),
                        'libelle': { type: 'contains', filter: props.filters.libelle },
                        'centre': { type: 'contains', filter: props.filters.centre },
                    };
                    gridOptions.api?.setFilterModel(filterModel);
                    filterChanged();
                    return;
                }

                if (gridApi && gridName === 'ag-grid-heritage-element') {
                    let filterModel = gridOptions.api?.getFilterModel();
                    let filterPassType;

                    delete filterModel.linkedAxis;
                    delete filterModel.direction;
                    delete filterModel.landmark;

                    if (props.filters) {
                        let type = props.filters.type;

                        let prStart;
                        let prEnd;

                        if (type === 'superieur') {
                            prStart = Number(props.filters.prStart) - Number(props.filters.prScaleSearch);
                            prEnd = Number(props.filters.prStart) + Number(props.filters.prScaleSearch);

                            filterPassType = {
                                type: 'contain',
                                filter: 'sup',
                            };

                            filterModel = {
                                ...filterModel,
                                filterPassType,
                            };

                        } else {
                            prStart = Number(props.filters.prStart);
                            prEnd = Number(props.filters.prEnd);

                            if (!prEnd) {
                                prEnd = 999;
                            }

                            if (!prStart) {
                                prStart = 0;
                            }
                        }

                        if (prStart > prEnd) {
                            let temp = prStart;
                            prStart = prEnd;
                            prEnd = temp;
                        }

                        let landMarkFilter = { type: 'inRange', filter: prStart, filterTo: prEnd };

                        filterModel = {
                            ...filterModel,
                            linkedAxis: { type: 'equals', filter: props.filters.linkedAxis || '' },
                            direction: { type: 'equals', filter: props.filters.direction || '' },
                            landmark: landMarkFilter,
                        };
                    }

                    gridOptions.api?.setFilterModel(filterModel);
                    return;
                }

                gridOptions.api?.setFilterModel(props.filters);
                filterChanged();
            }
        }, [props.filters]);


        useEffect(() => {
            if (gridApi && checkAll !== null && gridName === 'ag-grid-heritage-element' && !isLoading) {
                let selectedValues = [];
                gridApi.forEachNodeAfterFilter((node) => {
                    node.data.selected = checkAll;

                    if (checkAll) {
                        selectedValues.push(node.data);
                    }
                });
                gridApi.refreshCells();

                setGridSelectedValues(selectedValues);
            }
        }, [checkAll]);

        const onGridReady = (params) => {
            if (!gridApi) {
                setGridApi(params.api);

                loadColumns(params.columnApi);

                if (isLoading) {
                    setIsLoading(false);
                }
            }
        };

        // Sauvegarde de l'ordre (et état) des colonnes
        const columnStateChanged = () => {
            if (isLoading) return;

            const columnState = gridOptions.columnApi.getColumnState();
            const allColumns = JSON.parse(localStorage.getItem('columns')) || {};

            // Toujours garantir une structure uniforme
            if (!allColumns[gridName]) {
                allColumns[gridName] = {};
            }

            const typeKey = props.type || 'default';

            allColumns[gridName][typeKey] = columnState;

            localStorage.setItem('columns', JSON.stringify(allColumns));
        };


        // Chargement de l'ordre (et état) des colonnes
        const loadColumns = (columnApi = gridOptions.columnApi) => {
            const columns = JSON.parse(localStorage.getItem('columns'));

            if (!columnApi || !gridName || !columns || !columns[gridName]) return;

            const typeKey = props.type || 'default';
            const columnModel = columns[gridName][typeKey];

            if (Array.isArray(columnModel)) {
                columnApi.setColumnState(columnModel);
            }
        };

        const filterChanged = (event) => {
            if (isLoading) return;

            let filterModel = gridOptions.api.getFilterModel();
            let filters = JSON.parse(localStorage.getItem('filters')) || {};
            if (props.type) {
                if (!filters[gridName]) {
                    filters[gridName] = {};
                }
                filters[gridName][props.type] = filterModel;
            } else {
                filters[gridName] = filterModel;
            }
            localStorage.setItem('filters', JSON.stringify(filters));
        };

        const loadFilters = () => {
            if (isLoading) return;
            let filters = JSON.parse(localStorage.getItem('filters'));
            if (gridOptions.api && gridName && filters && filters[gridName]) {
                let filterModel = filters[gridName];
                if (props.type) {
                    filterModel = filterModel[props.type];
                }
                setTimeout(() => {
                    gridOptions.api?.setFilterModel(filterModel);
                }, 400);
            }
            if (filters && filters[gridName]) {
                if (props.type) {
                    return filters[gridName][props.type];
                }
                return filters[gridName];
            }
        };

        const handleScroll = (event) => {
            if (event.direction === 'horizontal') {
                if (!isResizing) {
                    setIsResizing(true);
                    setTimeout(() => {
                        setIsResizing(false);
                    }, 200);
                }
            }
        };

        const filteredColumnDefs = props.columnDefs.filter((column) => {
            if (!column.profile) return true;
            return column.profile.includes(profil.profil);
        });

        const resizeAllColumns = () => {
            if (!gridOptions.columnApi) return;
            const allColumnIds = [];
            gridOptions.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });

            if (gridOptions.columnApi && allColumnIds.length > 0) {
                setTimeout(() => {
                    gridOptions.columnApi?.autoSizeColumns(allColumnIds, false);
                }, 100);
            }
        };

        let className = `ag-theme-blue ${props.color ? props.color : ''}`;

        return (
            <div className={className} style={style || {
                boxSizing: 'border-box',
                height: props.pagination === true ? 'calc(100% - 55px)' : 'calc(100% - 50px)',
                width: '100%',
            }}>
                {props.rowData !== undefined && (
                    <AgGridReact
                        ref={props.ref ? props.ref : null}
                        rowData={props.rowData}
                        columnDefs={filteredColumnDefs}
                        rowHeight={props.rowHeight}
                        sortable={props.sortable}
                        unSortIcon={true}
                        animateRows={true}
                        rowSelection={rowSelection}
                        excelColumns={props.excelColumns}
                        excelStyles={excelStyles}
                        context={context}
                        gridOptions={props.gridOptions}
                        pagination={props.pagination !== null ? props.pagination : false}
                        paginationPageSize={props.paginationPageSize}
                        localeText={localeText}
                        suppressRowClickSelection={true}
                        frameworkComponents={props.frameworkComponents}
                        enableCellTextSelection={true}
                        reactUi={true}
                        maintainColumnOrder={true}
                        onGridReady={onGridReady}
                        onCellDoubleClicked={props.handleOnDoubleClick ? props.handleOnDoubleClick : null}
                        pinnedBottomRowData={props.pinnedBottomRowData ? props.pinnedBottomRowData : null}
                        onColumnValueChanged={props.onColumnValueChange ? props.onColumnValueChange : null}
                        onSortChanged={columnStateChanged}
                        onFilterChanged={(e) => filterChanged(e)}
                        onBodyScroll={(e) => handleScroll(e)}
                        onColumnMoved={columnStateChanged}
                        onColumnPinned={columnStateChanged} // Sauvegarde des pins
                        onColumnVisible={columnStateChanged} // Sauvegarde de la visibilité
                        onColumnResized={columnStateChanged}
                        onFirstDataRendered={(e) => {
                            if (isLoading) setIsLoading(false);
                            resizeAllColumns();
                        }}
                    />
                )}
            </div>
        );
    }
;

export default AgGrid;
